module.exports = __webpack_public_path__ + "static/media/imagen-cabecera.cb614ff3.png";